//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { GalleriesClientType } from '@galleries/selectors/getGalleriesClientType';

export enum Plurality {
  singular = 'singular',
  plural = 'plural',
  default = 'default',
}

export const getFeatureNames = (
  feature: GalleriesClientType,
): Record<Plurality, string> => {
  switch (feature) {
    case GalleriesClientType.instashop: {
      return {
        singular: 'InstaShop',
        plural: 'InstaShops',
        default: 'InstaShop',
      };
    }
    case GalleriesClientType.custom:
    case GalleriesClientType.galleries: {
      return {
        singular: 'Gallery',
        plural: 'Galleries',
        default: 'Galleries',
      };
    }
    case GalleriesClientType.none:
      return {
        singular: '',
        plural: '',
        default: '',
      };
  }
};

export const getFeatureName = (
  feature: GalleriesClientType,
  plurality: Plurality,
) => getFeatureNames(feature)[plurality];
